<template>

  <div>
    <AllPlansFilter @plansFilterChanged="plansFilterChanged" planType="dump"  />
    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
      </div>

      <div class="m-2">

        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col cols="12" md="3" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>{{ $t('Show') }}</label>
            <v-select v-model="perPage"
                    :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                      :options="perPageOptions"
                      :clearable="false" class="per-page-selector d-inline-block mx-50"/>
            <label>{{ $t('entries') }}</label>
          </b-col>

          
        <b-col cols="12" md="9">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input v-model="searchQuery" class="d-inline-block mr-1" placeholder="Search..." style="width:60%" />
              <b-button v-if="($store.getters['auth/user'].permissions.includes('plans.dump.create'))"
                variant="primary" :to="{ name: 'plans.dump.create' }">
                <span class="text-nowrap">{{ $t('Create Plan')}}</span>
              </b-button>

              <b-button @click.prevent="Export('xlsx')" type="button" class="mr-1 ml-1" variant="info">
                {{ $t('Export Excel') }}
              </b-button>

              <b-button @click.prevent="Export('pdf')" type="button" class="mr-1 ml-1" variant="info">
                {{ $t('Export PDF') }}
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
          ref="refPlansListTable"
          class="position-relative"
          :items="fetchPlans"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc">

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown class="actionIcon" variant="link" no-caret :right="$store.state.appConfig.isRTL">
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body"/>
            </template>
            <b-dropdown-item :to="{ name: 'plans.'+data.item.type+'.edit', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Edit') }}</span>
            </b-dropdown-item>

            <b-dropdown-item @click="removeDumpPlan(data.item.id)" v-if="$store.state.auth.userData.permissions.includes('plans.dump.destroy')">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">{{ $t('Delete')}}</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

        <!-- <template #cell(areas)="data">
          <b-badge style="margin: 0.2rem" pill variant="primary" v-for="area in data.item.areas"> {{ area.name }} ({{ data.item.data.filter(a => a.area == area.geofence_id)[0].count}})</b-badge>
        </template> -->
        <template #cell(areas)="data"  style="max-width:20%">
          <b-badge style="margin: 0.2rem" pill variant="primary" v-for="area in data.item.areas"  v-bind:key="area.id"> {{ area.name }} </b-badge>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">{{ $t('Showing') }} {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} {{$t('entries')}}</span>
          </b-col>
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalPlans"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18"/>
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18"/>
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>

import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import { onUnmounted, ref } from '@vue/composition-api'
import store from '@/store'
import plansStore from '@/views/modules/plans/functions/plansStore'
import usePlans from '@/views/modules/plans/functions/usePlans'
import PlanListAddNew from '@/views/modules/plans/garden-plan/plans-list/PlanListAddNew'
import formGetLinkedOptions from '@/views/modules/api/formGetLinkedOptions'
import { GardenPlanService } from '@/app/plans/garden/services/garden.plan.service'
import AllPlansFilter from '@/views/modules/plans/filters/AllPlansFilter.vue'
import { ExportDataServices } from '@/share/reports/exportService'


export default {
  components: {
    OrbitSpinner,
    BCard, BRow, BCol, BFormInput, BButton, BTable,
    BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination,
    vSelect, PlanListAddNew,AllPlansFilter
  },

  setup(props, {root}) {
    const plansFilterChanged=(plansFilterData)=>{  
   //  extairnalFilter.value=plansFilterData; 
     forceRefilter(plansFilterData)
        }
    const campsOption = ref([])

    const suctionOption = ref([])
    const dumpsOption = ref([])

    const devicesOptions = ref([])

    const landfillsOptions=ref([])
    
    const isAddNewPlanSidebarActive = ref(false)

    // Register module
    if (!store.hasModule('plans'))
      store.registerModule('plans', plansStore)

    // Register module
    if (!store.hasModule('formOptions'))
      store.registerModule('formOptions', formGetLinkedOptions)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule('plans'))
        store.unregisterModule('plans')

      if (store.hasModule('formOptions'))
        store.unregisterModule('formOptions')
    })


    const user = store.getters['auth/user']

    const setOptions = area => {
      switch (area.category) {
        case 'CAMP': campsOption.value.push(area); break
        case 'SUCTION_AREA': suctionOption.value.push(area); break
        case 'DUMP_AREA': dumpsOption.value.push(area); break
        case 'WORK_AREA': dumpsOption.value.push(area); break
        case 'LANDFILL': landfillsOptions.value.push(area); break
        
      }
    }

    store.dispatch('formOptions/getLinkedOptions', {
      user: user.id,
      type: 'geofence',
      cols: 'geofence_id,name,category'
    }).then(res => res.data.data.map(a => setOptions(a))).catch(reason => {})


    store.dispatch('formOptions/getLinkedOptions', {
      user: user.id,
      type: 'device',
      cols: 'device_id,name'
    }).then(res =>  devicesOptions.value = res.data.data ).catch(reason => {})
    const tableColumns = [
    { key: 'name', sortable: true,label: root.$t('Name')},
    { key: 'device', sortable: true, label: root.$t('device' )},
    { key: 'areas', sortable: true, label: root.$t('areas') },
    { key: 'owner', sortable: true, label: root.$t('owner') },
    { key: 'contract', sortable: true, label:  root.$t('contract') },
    { key: 'actions', label: root.$t('actions') },
  ]

    const {
      fetchPlans,forceRefilter, perPage, currentPage, totalPlans,
      dataMeta, perPageOptions, searchQuery, sortBy,
      isSortDirDesc, refPlansListTable, refetchData,
      requestStatus,extairnalFilter } = usePlans('dump')


    const removeDumpPlan = (id) => {
      root.$swal({
        title: root.$t("Are You Sure"),
        text: root.$t("Do you want to delete this plan?"),
        showCancelButton: true,
        confirmButtonText: root.$t('Delete'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          GardenPlanService.deletePlan(id,'dump').then(_ => {
                refetchData()
                root.$bvToast.toast(
                    root.$t('Plan Deleted Successfully'), {
                      title: root.$t('Success'),
                      variant: 'success',
                      solid: true, })
              }).catch(reason =>{
                root.$bvToast.toast(
                    root.$t('Unable to delete plan'), {
                      title: root.$t('Error'),
                      variant: 'danger',
                      solid: true, })

              })
        }
      })
    }
    const reformatArea=(data)=>{
      let custom=" ";
      for(let d in data.value){
         custom+=data.value[d].name+" ,"
      }

      return "["+custom+"]";
    }

    ///// export start ////////

const Export = (fileType) => {

requestStatus.value = true
const exportRquset=Object.assign({ exporter: fileType,export:'plansList' ,type:'dump' },extairnalFilter.value)
delete exportRquset.plans
ExportDataServices.exportReport(exportRquset).
  then(
    (res) => {
      requestStatus.value = false
    }
  ).catch(reason => {
    console.log('Export faild')
    requestStatus.value = false
  })


}
////export end /////////
    return {
      removeDumpPlan,
      isAddNewPlanSidebarActive,

      campsOption,
      suctionOption,
      dumpsOption,

      devicesOptions,
      landfillsOptions,
      forceRefilter,
      fetchPlans,
      totalPlans,
      perPage,
      requestStatus,
      refPlansListTable,
      dataMeta,
      tableColumns,
      currentPage,
      refetchData, sortBy, searchQuery, perPageOptions, isSortDirDesc,
      reformatArea,plansFilterChanged,
      Export
    }

  }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.per-page-selector {
  width: 90px;
}
.actionIcon > button {
  padding: 0;
}

.table > tbody > tr > td {
max-width: 300px;

}


</style>
